<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center p-3"
    :class="containerClass"
    v-animate-css="'fadeIn'"
  >
    <b-img
      v-if="icon"
      :src="icon"
      :alt="message || $t('shared.nothingFound')"
      class="mb-3"
      :width="iconWidth"
      :height="iconHeight"
    />

    <component
      :is="messageTag"
      v-if="!noMessage"
      :class="['text-muted text-center', messageClass]"
    >
      {{ message || $t('shared.nothingFound') }}
    </component>

    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BrbEmptyView',
  props: {
    icon: String,
    iconWidth: {
      default: 100
    },
    iconHeight: {
      default: 100
    },
    message: String,
    messageTag: {
      type: String,
      default: 'span'
    },
    messageClass: [String, Array, Object],
    noMessage: Boolean,
    containerClass: [String, Array, Object]
  }
}
</script>
